import * as actions from '@lib/actions/AuthenticationAction';
import { addTranslateToProps, ITranslationProps } from '@lib/i18n/translation';
import Register from '@lib/pages/Register';
import { IStoreAuthenticationState } from '@lib/types/index';

import { connect, Dispatch } from 'react-redux';

export function mapStateToProps(state: any): IRegisterProps {
  const authentication: IStoreAuthenticationState = state.authentication;
  return addTranslateToProps({
    confirmation: authentication.confirmation,
    errorMessage: authentication.errorMessage,
    login: authentication.login,
    password: authentication.password,
  })
}

export function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onGoHome: () => dispatch(actions.signOutAction()),
    onSignup: (login: string, password: string) => dispatch(actions.asyncRegisterAction(login, password)),
  }
}

interface IRegisterProps extends ITranslationProps {
  confirmation: string,
  errorMessage: string,
  login: string;
  password: string;
}

interface IRegisterDispatchProps {
  onSignup(login: string, password: string): void;
  onGoHome(): void;
}

export type RegisterProps = IRegisterProps & IRegisterDispatchProps;

export default connect<IRegisterProps, IRegisterDispatchProps, any>(mapStateToProps, mapDispatchToProps)(Register);


// WEBPACK FOOTER //
// ./src/containers/Register.tsx